import React from 'react';
import { Query } from 'react-apollo';
import * as _ from 'lodash';
import { useDispatch } from 'react-redux';
import { Button } from 'primereact/button';
import { PropTypes } from 'prop-types';
import { Card } from 'primereact/card';
import { Loading } from '../components/Loading';
import { APP_BASENAME } from '../config';
import { ACCOUNT_LIST } from '../components/Query';
import { addLoggedAccount } from '../reducers/account';

const AccountSelectionList = ({ onAccountSelect }) => {
  const dispatch = useDispatch();

  const addAccount = account => dispatch(addLoggedAccount(account));

  return (
    <Query query={ACCOUNT_LIST} variables={{ first: 999 }}>
      {
        ({ data, loading, error }) => {
          if (error) {
            return 'Error';
          }

          if (loading) {
            return <Loading />;
          }

          const accountsInfo = _.map(data.viewer.accounts.edges, edge => ({
            id: edge.node.id,
            displayName: edge.node.displayName,
            type: edge.node.type,
            logoUrl: edge.node.brandingInformation.logo.url,
          }));

          return (
            <div className="p-col-12">
              <div className="p-grid">
                {
                  accountsInfo.map(accInfo => (
                    <div
                      key={accInfo.id}
                      className="p-col-12 p-md-6 p-sm-4 p-lg-3"
                    >
                      <Button
                        className="p-button-secondary align-center account-wrapper"
                        onClick={() => {
                          addAccount(accInfo.id);
                          onAccountSelect(accInfo.id);
                        }}
                        style={{ height: '256px' }}
                      >
                        <Card
                          style={{ textAlign: 'center' }}
                        >
                          <div>
                            <img
                              src={accInfo.logoUrl ? accInfo.logoUrl : `${APP_BASENAME}/images/default-logo.png`}
                              alt={accInfo.logoUrl ? accInfo.logoUrl : 'default logo'}
                              style={{
                                height: '128px',
                                width: 'auto',
                                maxWidth: '100%',
                                objectFit: 'contain',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                padding: '5px',
                              }}

                            />
                          </div>

                          <div style={{ height: '32px', fontWeight: 'bold' }}>
                            {accInfo.displayName}
                          </div>

                          <div style={{ height: '32px', fontStyle: 'italic' }}>
                            {`${accInfo.type}`}
                          </div>
                        </Card>
                      </Button>
                    </div>
                  ))
                }
              </div>
            </div>
          );
        }
      }
    </Query>
  );
};

AccountSelectionList.propTypes = {
  onAccountSelect: PropTypes.func.isRequired,
};

export default AccountSelectionList;
